
<!--
2025-01-16

This class should not be necessary, but because locations and in
general the integration with the backend is chaotic.
We need to handle this in the front end until this is
refactored and done properly

This component exists to manage location types, colors and naming conventions
centrally

For example Country Group -> Region
City -> Location
Location -> Harbour.

This occurred due to very bad requirements engineering, and communication failure
between customer, analyst, designer and developer.

-->


<script setup lang="ts">

import {useI18n} from "vue-i18n";

const props = defineProps(['destination'])
const {t} = useI18n()

</script>
<template>
   <div
      :class="`responsive-body-small px-2 py-1 rounded-11xl
                ${ props.destination.entity.toLowerCase() == 'harbour' ? 'bg-primary-ciel' : ''}
                ${props.destination.entity.toLowerCase() == 'country' ? 'bg-primary-green' : ''}
                ${props.destination.entity.toLowerCase() == 'location' ? 'bg-primary-yellow' : ''}
                ${ props.destination.entity.toLowerCase() == 'region' ? 'bg-primary-mouve' : ''}`">
      {{ t('global.ui.destination.entity.'+props.destination.entity.toLowerCase()) }}
   </div>


</template>